import React from "react";
import { motion } from "framer-motion";

/**
 * Kinetic line-by-line reveal.
 * Wraps each line in an overflow-hidden container; inner span translates from y:100% to 0.
 */
export default function RevealLines({
  lines = [],
  as = "h1",
  className = "",
  delay = 0.05,
  stagger = 0.09,
  duration = 0.9,
  lineClassName = "",
  once = true,
}) {
  const Tag = motion[as] || motion.h1;
  const container = {
    hidden: {},
    visible: {
      transition: { staggerChildren: stagger, delayChildren: delay },
    },
  };
  const line = {
    hidden: { y: "115%", opacity: 0.001 },
    visible: {
      y: "0%",
      opacity: 1,
      transition: { duration, ease: [0.16, 1, 0.3, 1] },
    },
  };

  return (
    <Tag
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, amount: 0.4 }}
      variants={container}
    >
      {lines.map((text, i) => (
        <span key={i} className={`line-mask ${lineClassName}`}>
          <motion.span variants={line}>{text}</motion.span>
        </span>
      ))}
    </Tag>
  );
}
